<template>
  <modal
    :id="modalId"
    :componentKey="componentKey"
    ref="modal"
    @close="close"
    is-simplified-modal
    title="Edit Knowledge base category"
  >
    <template v-slot:body>
      <div>
        <!-- Title Container with colored background -->
        <div class="bg-primary-extra-lightest p-5">
          <div class="text-sm italic text-gray-700 mb-4">
            All fields with asterisk (*) are mandatory
          </div>

          <form-group>
            <DsInput
              v-model="categoryName"
              type="text"
              placeholder="Category Name *"
              class="w-full"
              required
              ref="nameInput"
              is-simplified
            />
          </form-group>
        </div>

        <!-- Content Container -->
        <div v-if="errors && errors.length > 0" class="px-5 py-5 pb-4">
          <div class="text-sm mb-2">
            <div v-for="message in errors" :key="message" class="text-red-600">
              <span>{{ message }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="w-full">
        <ds-button
          variant="rounded"
          @click="updateCategory"
          label="Update Category"
          size="extra-small"
          :disabled="!canSubmit"
          class="w-full"
        />
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/Modals/Modal.vue'
  import FormGroup from '@/components/Form/FormGroup.vue'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'
  import MODAL_IDS from '@/constants/modal-ids.js'
  import DsInput from '@/components/Form/DsInput.vue'
  import { updateCategory } from '@/api/knowledge-base'

  export default {
    name: 'EditKnowledgeBaseCategoryModal',
    components: {
      DsInput,
      Modal,
      FormGroup
    },
    data () {
      return {
        modalId: 'edit-category-modal',
        componentKey: 0,
        categoryName: '',
        errors: [],
        minNameLength: 2,
        category: null,
        isLoading: false
      }
    },
    computed: {
      canSubmit () {
        return this.categoryName &&
          this.categoryName.trim().length >= this.minNameLength &&
          !this.isLoading
      },
      modalContext () {
        return this.$store.state.ui.modalContext
      }
    },
    watch: {
      modalContext: {
        handler (newContext) {
          if (newContext && newContext.category) {
            this.loadCategoryData(newContext.category)
          }
        },
        immediate: true
      }
    },
    mounted () {
      // Focus the name input when modal opens
      this.$nextTick(() => {
        this.$refs.nameInput?.focus()
      })
    },
    methods: {
      loadCategoryData (category) {
        this.category = category
        this.categoryName = category.name || ''
        this.errors = []
      },
      close () {
        // Reset form
        this.categoryName = ''
        this.errors = []
        this.category = null

        // Close modal
        this.$store.commit(UI_MUTATION_TYPES.HIDE_MODAL, MODAL_IDS.EDIT_KNOWLEDGE_BASE_CATEGORY)
        this.$emit('close')
      },
      validateForm () {
        this.errors = []

        if (!this.categoryName || this.categoryName.trim().length < this.minNameLength) {
          this.errors.push(`Category name must be at least ${this.minNameLength} characters long`)
        }
      },
      async updateCategory () {
        this.validateForm()
        this.componentKey++

        if (this.errors.length > 0 || !this.category) {
          return
        }

        this.isLoading = true

        try {
          const categoryData = {
            name: this.categoryName.trim()
          }

          await updateCategory(this.category.id, categoryData)

          // Emit event to parent component
          this.$bus.emit('category-updated', {
            ...this.category,
            ...categoryData
          })

          this.close()
        } catch (error) {
          console.error('Failed to update category:', error)
          this.errors.push('Failed to update category. Please try again.')
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
